export const comments_3257610 = {"data":{"data":[],"links":{}}}